<template>
  <div class="recommended-org" @click.prevent="handleClick">

      <p class="recommended-org__section-title">Recommended Org</p>

      <div v-if="recommended_org" class="recommended-org__body">

        <!-- left -->
        <div class="recommended-org__left">
          <div v-if="recommended_org['logo']" class="recommended-org__img-container">
            <img class="recommended-org__img" :src="recommended_org['logo']" :alt="recommended_org['org-name']">
          </div>
        </div>

        <!-- right -->
        <div class="recommended-org__right">
          <div class="recommended-org__header">
            <div class="recommended-org__header-group">
              <h3 v-if="recommended_org['org-name']" class="recommended-org__title">{{ recommended_org['org-name'] }}</h3>

              <div class="recommended-org__icons">
                <div class="recommended-org__icons-item">
                  <img src="/images/icons/shared/lady.svg" class="recommended-org__icons-item-icon" alt="" title="Lady"/>
                </div>

                <!-- <div class="recommended-org__icons-item">
                  <img src="/images/icons/shared/artboard.svg" class="recommended-org__icons-item-icon" alt="" title="Art Board"/>
                </div>

                <div class="recommended-org__icons-item">
                  <img src="/images/icons/shared/church.svg" class="recommended-org__icons-item-icon" alt="" title="Church"/>
                </div> -->

                <div class="recommended-org__icons-item">
                  <img src="/images/icons/shared/top100.svg" class="recommended-org__icons-item-icon" alt="Escape Top 100" title="Escape Top 100"/>
                </div>
              </div>
            </div>

            <block-action-follow-org :org_main_id="recommended_org['org-main-id']" :org_name="recommended_org['org-name']"></block-action-follow-org>
          </div>

          <div v-if="recommended_org['listings-live']" class="recommended-org__btn--roles">
            <img src="/images/icons/organisation/briefcase.svg" class="recommended-org__icons-item-icon" alt="Briefcase" />
            {{ recommended_org['listings-live'] }} active roles
          </div>

          <div class="recommended-org__stats">
            <div v-if="recommended_org['review-score-latest'] && recommended_org['reviews-total']" class="recommended-org__stats-item" title="Organisation Reviews">
              <svg class="recommended-org__stats-item-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 12"><path fill="#F9AE13" d="M4.453 4.031l.797-1.875L6.422 0l2.11 3.703 2.671.328 1.64.188-3.327 3.515 1.171 4.22-2.25-1.454L6.47 9.14 2.906 11.72 2.11 12l1.079-4.5L0 4.172l1.828-.188 2.625.047z"/></svg>
              {{ recommended_org['review-score-latest'] }}&nbsp;<span>({{ recommended_org['reviews-total'] }})</span>
            </div>

            <div v-if="recommended_org['city'] && recommended_org['city']" class="recommended-org__stats-location" title="Organisation Location/Remote">
              {{ recommended_org['city'] }}/{{ recommended_org['remote'] }}
            </div>
          </div>

        </div>

      </div>

  </div>
</template>

<script>

import AuthMixins from '@/mixins/AuthMixins';
import RecommendedOrgs from '@/mixins/RecommendedOrgs';

export default {
  mixins: [AuthMixins, RecommendedOrgs],

  data() {
    return {
      recommended_org: false
    }
  },

  mounted() {

  },

  methods: {
    handleClick() {
			if (this.recommended_org) {
      	this.emitter.emit("openModal", { name: 'recommendedOrgs' });
			}
    }
  }
}
</script>

